export function formatCount(value) {
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return "0";

  const abs = Math.abs(num);
  if (abs >= 1_000_000_000) return `${trim(num / 1_000_000_000)}b`;
  if (abs >= 1_000_000) return `${trim(num / 1_000_000)}m`;
  if (abs >= 1_000) return `${trim(num / 1_000)}k`;
  return String(Math.round(num));
}

function trim(value) {
  const rounded = Number(value.toFixed(1));
  return Number.isInteger(rounded) ? String(Math.trunc(rounded)) : String(rounded);
}
